import {
    SHOW_NO_USAGE_OR_CANCEL_SURGERY_POPUP,
    CANCEL_USAGE_ORDER_COMPLETION,
    CANCEL_USAGE_ORDER,
    RESET_CANCEL_USAGE_STATES,
    SET_SHOW_CONTACT_LOGISTICS_POPUP,
} from '../action/types';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

const initialState = {
    showCancelSurgeryPopup: false,
    showNoUsageToReportPopup: false,
    viewProcedureScreen: false,
    cancelSurgeryData: {},
    cancelReason: null,
    isFromOrderDetailsModal: false,
    showUnidPostponePopup: false,
    showCaseCancelOrPostpone: false,
};

const noUsageToReportReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case RESET_CANCEL_USAGE_STATES:
            return {
                ...initialState,
                showContactLogisticsPopup: state.showContactLogisticsPopup,
            };
        case SHOW_NO_USAGE_OR_CANCEL_SURGERY_POPUP:
            return {
                ...state,
                showCancelSurgeryPopup: action.payload.showCancelPopup,
                showNoUsageToReportPopup: action.payload.showNoUsagePopup,
                cancelSurgeryData: action.payload.surgeryData,
                viewProcedureScreen: action.payload.viewProcedureScreen,
                cancelReason: action.payload.cancelReason,
                isFromOrderDetailsModal: action.payload.isFromOrderDetailsModal,
                showUnidPostponePopup: action.payload.showUnidPostponePopup,
                showCaseCancelOrPostpone:action.payload.showCaseCancelOrPostpone,
            };
        case CANCEL_USAGE_ORDER:
            return {
                ...state,
                cancelUsageInProgress: true,
                isCancelWithoutReason: action.payload.isCancelWithoutReason,
                isFromOrderDetailsModal: action.payload.isCancelWithoutReason
                    ? action.payload.isFromOrderDetailsModal
                    : state.isFromOrderDetailsModal,
            };
        case SET_SHOW_CONTACT_LOGISTICS_POPUP: {
            return {
                ...state,
                showContactLogisticsPopup: action.payload,
            };
        }
        case CANCEL_USAGE_ORDER_COMPLETION:
            return {
                ...state,
                cancelUsageResponse: action.payload,
                cancelUsageInProgress: false,
            };
        default:
            return {
                ...state,
            };
    }
};

// export default noUsageToReportReducer;
export default persistReducer(
    {
        key: 'nutrProcedure',
        storage: storage,
        //transforms: [SetTransform],
    },
    noUsageToReportReducer
);